import { render, staticRenderFns } from "./MultiLoanApplicationForm.vue?vue&type=template&id=c5e06e9a&"
import script from "./MultiLoanApplicationForm.vue?vue&type=script&lang=ts&"
export * from "./MultiLoanApplicationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports